import { useMutation } from '@tanstack/react-query';
import useHttpClient from 'hooks/useHttpClient';

export function useSendMessage({ onSuccess, onError }) {
  const { formData } = useHttpClient();

  return useMutation({
    mutationFn: async ({ message, conversationId }) => {
      const response = await formData({
        url: 'https://behavior-analysis.oneforce.ai/api/chat',
        headers: {},
        payload: [{ type: 'prompt', value: message }],
        // {
        //   question: message,
        //   conversation_id: conversationId,
        //   timestamp: new Date().toISOString(),
        // },
      });
      return response;
    },
    onSuccess: (data, variables) => {
      if (onSuccess) {
        onSuccess(data, variables);
      }
    },
    onError: (error, variables) => {
      if (onError) {
        onError(error, variables);
      }
    },
  });
}
